"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
class GetNextBestBase extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)({ name: 'profile_id' }),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'Profile ID as retrieved from the Identification Service',
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestBase.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.Channel)),
    (0, base_models_1.Docs)({
        example: offerstore_api_models_1.Channel.MIJN,
        description: `Should be left empty since channel is now read from the api key.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestBase.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears), { each: true }),
    (0, base_models_1.Docs)({
        example: [base_models_1.DurationInYears.FLEX],
        description: 'Specify for which durations you want to filter the propositions for.',
    }),
    tslib_1.__metadata("design:type", Array)
], GetNextBestBase.prototype, "durations", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType), { each: true }),
    (0, class_transformer_1.Expose)({ name: 'segment_types' }),
    (0, base_models_1.Docs)({
        example: [base_models_1.SegmentType.SOHO],
        description: `Filter for which segment you want to offers for.
Not all offers are created for all segments.
For example 'SME acq VAR Plus DF (nov)' is only for SME customers.`,
    }),
    tslib_1.__metadata("design:type", Array)
], GetNextBestBase.prototype, "segmentTypes", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.ProductType), { each: true }),
    (0, class_transformer_1.Expose)({ name: 'product_types' }),
    (0, base_models_1.Docs)({
        example: [offerstore_api_models_1.ProductType.ELECTRICITY],
        description: `Filter for which transition rules as defined by the campaign management the campaign (and thus the proposition) should match`,
    }),
    tslib_1.__metadata("design:type", Array)
], GetNextBestBase.prototype, "productTypes", void 0);
exports.default = GetNextBestBase;
